import { ArrowDownRight, ArrowUpRight, Minus } from "lucide-react";

/** Dependency-free SVG sparkline. */
function Path({ values, color, w = 132, h = 36 }) {
  if (!values || values.length === 0) {
    return <div style={{ height: h }} className="flex items-center text-[11px] text-white/40">no data yet</div>;
  }
  const min = Math.min(...values);
  const max = Math.max(...values);
  const span = max - min || 1;
  const n = values.length;
  const pts = values.map((v, i) => {
    const x = n === 1 ? w : (i / (n - 1)) * w;
    const y = h - ((v - min) / span) * (h - 4) - 2;
    return [x, y];
  });
  const d = pts.map((p, i) => `${i === 0 ? "M" : "L"}${p[0].toFixed(1)},${p[1].toFixed(1)}`).join(" ");
  const area = `${d} L${w},${h} L0,${h} Z`;
  const gid = `sg-${color.replace("#", "")}`;
  return (
    <svg width="100%" height={h} viewBox={`0 0 ${w} ${h}`} preserveAspectRatio="none" className="overflow-visible">
      <defs>
        <linearGradient id={gid} x1="0" y1="0" x2="0" y2="1">
          <stop offset="0%" stopColor={color} stopOpacity="0.35" />
          <stop offset="100%" stopColor={color} stopOpacity="0" />
        </linearGradient>
      </defs>
      <path d={area} fill={`url(#${gid})`} />
      <path d={d} fill="none" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
      <circle cx={pts[pts.length - 1][0]} cy={pts[pts.length - 1][1]} r="2.6" fill={color} />
    </svg>
  );
}

export default function Sparkline({ metric, color = "#38bdf8", testid }) {
  if (!metric) return null;
  const { label, unit, values = [], current = 0, delta = 0 } = metric;
  const Trend = delta > 0 ? ArrowUpRight : delta < 0 ? ArrowDownRight : Minus;
  const trendColor = delta > 0 ? "text-emerald-300" : delta < 0 ? "text-rose-300" : "text-white/50";
  return (
    <div
      className="rounded-2xl bg-white/[0.05] border border-white/[0.10] p-3.5 hover:bg-white/[0.07] transition-colors"
      data-testid={testid}
    >
      <div className="flex items-center justify-between mb-1">
        <span className="text-[11px] uppercase tracking-wider text-white/60">{label}</span>
        <span className={`inline-flex items-center gap-0.5 text-[11px] font-semibold ${trendColor}`}>
          <Trend className="w-3 h-3" />{delta > 0 ? "+" : ""}{delta}
        </span>
      </div>
      <div className="flex items-end gap-2">
        <span className="text-[22px] font-semibold text-white leading-none tabular-nums">
          {current}<span className="text-[12px] text-white/50 ml-0.5">{unit}</span>
        </span>
      </div>
      <div className="mt-1.5">
        <Path values={values} color={color} />
      </div>
    </div>
  );
}
